import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'nullToDash' })
export class nullToDashPipe implements PipeTransform {
	transform(value: any, treatZeroAsNull: boolean = true): any {
		if (
			value === null ||
			value === undefined ||
			value === '' ||
			(treatZeroAsNull && (value === 0 || value === '0')) ||
			(typeof value === 'string' &&
				(value.trim().toLowerCase() === 'null' || value.trim() === '0' || value.trim() === '0000-00-00 00:00:00')) // <-- aquí cubres la fecha inválida
		) {
			return ' - ';
		}
		return value;
	}
}
